import Box from "@material-ui/core/Box";
import React, { FC, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { mode } from "../../../App";
import { colorDark, colorLight } from "../../../theme";
import { VIEW } from "../../../utils/constant";
import { useLazyQuery } from "@apollo/client";
import {
  ACCESS_TOKEN_KEY,
  clearLocalStorage,
} from "../../../services/LocalStorage";
import UserInactivity from "./UserInactivity";
import CustomProgress from "../CustomProgress/CustomProgress";
import { TokenExpiration } from "../../../graphql/graphql_information/auth/types/TokenExpiration";
import { TOKEN_EXPIRATION } from "../../../graphql/graphql_information/auth/query";
import { informationClient } from "../../../apolloClient";
import useMyAccount from "../../customHooks/ledger/ledger";
import useAllAccount from "../../customHooks/ledger/allLedger";
import useMyInformation from "../../../hooks/company/information";
import SignedMandate from "../../MandatePnvt/SignedMandate";

const Layout: FC = () => {
  const { loading: loadingInfo } = useMyInformation(true);
  const { loading: loadingLedgers } = useAllAccount(true);
  const { loading: loadingLedger } = useMyAccount(true);

  // check token if valid
  const [checkToken] = useLazyQuery<TokenExpiration>(TOKEN_EXPIRATION, {
    client: informationClient,
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data && !data.tokenExpiration) {
        tokenNotValid();
      }
    },
    onError: () => {
      tokenNotValid();
    },
  });

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (token) {
      checkToken();
    }
  }, []);
  // if has not connection

  const tokenNotValid = () => {
    clearLocalStorage();
    window.location.href = "/";
  };

  if (loadingInfo) {
    return <CustomProgress />;
  }
  return (
    <Box>
      <UserInactivity>
        {(loadingLedgers || loadingLedger) && <CustomProgress />}
        <Box display="flex" height="100vh">
          <Box
            flex={1}
            bgcolor={
              mode === VIEW.LIGHT
                ? colorLight.appBackground
                : colorDark.appBackground
            }
            height="100vh"
          >
            <SignedMandate />
          </Box>
        </Box>
        <Outlet />
      </UserInactivity>
    </Box>
  );
};
export default Layout;
